import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";

export const requestRestoreReseller = async (
  resellerId: string
): Promise<void> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesResellers.Reseller,
      resellerId,
      ApiRoutesResellers.Restore
    )
  );
};
